import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { getQueryParam } from "utils";
import { emailWithOutlookCallback } from "../actions";

interface IEmailWithOutlookRedirect { }

const EmailWithOutlookRedirect: React.FC<IEmailWithOutlookRedirect> = (props: IEmailWithOutlookRedirect) => {
  const campaignId = sessionStorage.getItem("campaign_id");
  const emailId = sessionStorage.getItem("email_id");
  const history = useHistory();

  useEffect(() => {
    const code = getQueryParam("code");
    const state = getQueryParam("state");
    const sessionState = getQueryParam("session_state");
    emailWithOutlookCallback(code, state, sessionState, campaignId, emailId, history);
  }, []);
  return <></>;
};

export default EmailWithOutlookRedirect;
